import { Hex } from 'viem';
import { DashboardData } from '../../types/dashboard-data';
import { api } from '../api';

export const DashboardApi = {
  getUserInfo: async () => {
    const { data } = await api.get<DashboardData>('/dashboard');

    return data;
  },
  getWalletMessage: async (wallet: string) => {
    const { data } = await api.get<string>(`/dashboard/wallet/${wallet}/message`);

    return data;
  },
  linkWallet: async ({ wallet, data }: { wallet: string, data: { signature: Hex } }) => {
    await api.post(`/dashboard/wallet/${wallet}/link`, data);
  },
  unlinkWallet: async (wallet: string) => {
    await api.post(`/dashboard/wallet/${wallet}/unlink`);
  },
  setMainWallet: async (wallet: string) => {
    await api.post(`/dashboard/wallet/${wallet}/setmain`);
  },
};
